import {
    Box,
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { useEffect } from "react";
const cropMetricMap = {
    hops: ["yield_t","alpha_acid","beta_acid","oil_content","cone_moisture_pct","cohumulone_pct"],
    vineyard: ["yield_t","brix","titratable_acidity","ph","anthocyanin","phenolics","berry_weight_g","cluster_weight_g","malic_acid","yan"],
    coffee: ["yield_t","cup_score","bean_density_g_cm3","bean_screen_size","defect_rate_pct","caffeine_pct","moisture_content_pct","uniformity_score","chlorogenic_acid_pct"],
    wheat: ["yield_t","protein_pct","test_weight_kg_hl","falling_number","thousand_kernel_weight_g"],
    barley: ["yield_t","protein_pct","test_weight_kg_hl","plumpness_pct","beta_glucan"],
    oats: ["yield_t","test_weight_kg_hl","groat_pct","beta_glucan","oil_content_pct"],
    strawberry: ["yield_t","brix","berry_weight_g","firmness","titratable_acidity","shelf_life_days"],
    blueberry: ["yield_t","brix","berry_weight_g","firmness","anthocyanin","shelf_life_days"],
    raspberry: ["yield_t","brix","berry_weight_g","firmness","anthocyanin","defect_rate_pct"]
};

const LOCKED_METRIC = "yield_t";
const MAX_ADDITIONAL = 5;

export default function CropMetrics({ form, setForm, cropTypes, translate }) {
    const normalizedCropTypes =
        Array.isArray(cropTypes?.[0]) ? cropTypes[0] : cropTypes || [];

    const crop =
        normalizedCropTypes.find(
            (t) => String(t.crop_type_id) === String(form.crop_type)
        );

    const cropName =
    typeof crop?.crop_name === "string"
        ? crop.crop_name.toLowerCase()
        : "";
    useEffect(() => {
    const validMetrics =
        selectedMetrics.filter((m) =>
            availableMetrics.includes(m)
        );

    const nextMetrics =
        validMetrics.length
            ? validMetrics
            : [LOCKED_METRIC];

    const hasChanged =
        JSON.stringify(nextMetrics) !==
        JSON.stringify(form.crop_metrics);

    if (hasChanged) {
        setForm((prev) => ({
            ...prev,
            crop_metrics: nextMetrics,
        }));
    }
}, [cropName]);
    const availableMetrics =
        cropMetricMap[cropName] || [LOCKED_METRIC];

    const selectedMetrics = Array.isArray(form.crop_metrics)
        ? form.crop_metrics.filter((m) =>
            availableMetrics.includes(m)
        )
        : [LOCKED_METRIC];

    const handleChange = (event) => {
        const metrics = event.target.value
            .filter((m) => m !== LOCKED_METRIC)
            .slice(0, MAX_ADDITIONAL);

        setForm((prev) => ({
            ...prev,
            crop_metrics: [LOCKED_METRIC, ...metrics],
        }));
    };

    const selectedCount =
        selectedMetrics.filter(
            (m) => m !== LOCKED_METRIC
        ).length;

    return (
        <Box sx={{ mt: 2 }}>
            <Typography sx={{ mb: 1, fontWeight: 700 }}>
                {translate("prediction_metrics")}
            </Typography>

            <FormControl fullWidth>
                <InputLabel>
                    {translate("prediction_metrics")}
                </InputLabel>

                <Select
                    multiple
                    value={selectedMetrics}
                    onChange={handleChange}
                    label={translate("prediction_metrics")}
                    renderValue={(selected) =>
                        selected
                            .map((metric) => translate(metric))
                            .join(", ")
                    }
                >
                    {availableMetrics.map((metric) => (
                        <MenuItem
                            key={metric}
                            value={metric}
                            disabled={
                                !selectedMetrics.includes(metric) &&
                                selectedCount >= MAX_ADDITIONAL
                            }
                        >
                            <Checkbox
                                checked={selectedMetrics.includes(metric)}
                                disabled={metric === LOCKED_METRIC}
                            />

                            <ListItemText
                                primary={translate(metric)}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}